// removed by extract-text-webpack-plugin
module.exports = {"sul-container":"sul-list__sul-container__rCgVd","loading-container":"sul-list__loading-container__3hzL1","list-title":"sul-list__list-title__3kJML","ul-container":"sul-list__ul-container__3896k","li-container":"sul-list__li-container__3Nfer","sul-name":"sul-list__sul-name__3vnZC","name":"sul-list__name__1C7HP","notes":"sul-list__notes__3Q4Qz","button-wrapper":"sul-list__button-wrapper__2eg1z","button-inner":"sul-list__button-inner__1YQNc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/SignUpListContainer/SULList/sul-list.scss
// module id = 1393
// module chunks = 1